import {FC} from "react";
import {DrawModel} from "../../core/_models";
import LiveVideoWrapper from "../live/LiveVideoWrapper";
import {DrawingResult} from "./DrawingResult";
import {gameType} from "../../../../constants/config";

type props = {
    draw: DrawModel,
    type: string
}

const DrawingWrapper: FC<props> = ({draw, type}) => {

    if (type === gameType.manual) return <LiveVideoWrapper draw={draw}/>
    return <DrawingResult tableId={draw.tableId!}/>
}
export default DrawingWrapper;